export default __webpack_public_path__ + "static/media/store.1855eff1.svg";